import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-306cd805"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p data-v-306cd805><a href=\"https://www.linkedin.com/company/towkns/\" target=\"_blank\" data-v-306cd805><svg data-v-306cd805><g clip-path=\"url(#a)\" data-v-306cd805><path d=\"M22.223 0H1.772C.792 0 0 .773 0 1.73v20.536C0 23.222.792 24 1.772 24h20.451c.98 0 1.777-.778 1.777-1.73V1.73C24 .773 23.203 0 22.223 0ZM7.12 20.452H3.558V8.995H7.12v11.457ZM5.34 7.434a2.064 2.064 0 1 1 0-4.125 2.063 2.063 0 0 1 0 4.125Zm15.112 13.018h-3.558v-5.57c0-1.326-.024-3.037-1.852-3.037-1.851 0-2.133 1.449-2.133 2.944v5.663H9.356V8.995h3.413v1.566h.047c.473-.9 1.636-1.852 3.365-1.852 3.605 0 4.27 2.372 4.27 5.457v6.286Z\" data-v-306cd805></path></g><defs data-v-306cd805><clipPath id=\"a\" data-v-306cd805><path d=\"M0 0h24v24H0z\" data-v-306cd805></path></clipPath></defs></svg></a><a href=\"https://twitter.com/TowknsApp\" target=\"_blank\" data-v-306cd805><svg data-v-306cd805><path d=\"M7.55 21.75c9.055 0 14.008-7.503 14.008-14.008 0-.211-.004-.427-.014-.638A9.999 9.999 0 0 0 24 4.555c-.898.4-1.85.66-2.826.774a4.95 4.95 0 0 0 2.165-2.723A9.897 9.897 0 0 1 20.213 3.8a4.93 4.93 0 0 0-8.394 4.49A13.985 13.985 0 0 1 1.673 3.15a4.93 4.93 0 0 0 1.523 6.57 4.93 4.93 0 0 1-2.23-.614v.06a4.922 4.922 0 0 0 3.95 4.829 4.893 4.893 0 0 1-2.221.084 4.933 4.933 0 0 0 4.597 3.422A9.875 9.875 0 0 1 0 19.538a13.969 13.969 0 0 0 7.55 2.212Z\" data-v-306cd805></path></svg></a></p><br data-v-306cd805><p data-v-306cd805><small data-v-306cd805><strong data-v-306cd805>Say hi.</strong> Email us at <a href=\"mailto:hi@towkens.com\" data-v-306cd805>hi@towkens.com</a></small></p><br data-v-306cd805>", 4)
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", null, [
      _createElementVNode("small", null, [
        _createVNode(_component_router_link, {
          class: "footer__legal-link",
          to: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Logo)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "footer__legal-link",
          to: "terms"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Terms of Service ")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "footer__legal-link",
          to: "privacy"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Privacy Policy ")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "footer__legal-link",
          to: "beta-terms"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Beta terms ")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_6,
    _createElementVNode("p", null, [
      _createElementVNode("small", null, [
        _createTextVNode(" Copyright © " + _toDisplayString(_ctx.currentYear) + " ", 1),
        _createVNode(_component_Logo),
        _createTextVNode(" · All rights reserved · Enjoy the rest of your " + _toDisplayString(_ctx.today) + "! ", 1)
      ])
    ])
  ]))
}